var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cloud-box"},[_c('div',{staticClass:"cf-turnstile",attrs:{"id":"cloudflare-block","data-sitekey":"0x4AAAAAAAcQl-bV-nkc3JPX","data-callback":"javascriptCallback"}})])
}]

export { render, staticRenderFns }